import { ConfigProvider } from "antd";
import { FC, PropsWithChildren } from "react";

export const Theme: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            colorBorder: "#8DC467",
            colorTextPlaceholder: "#011602",
            colorIcon: "#011602",
            activeBorderColor: "#8DC467",
            hoverBorderColor: "#8DC467",
            controlHeight: 50,
            fontSize: 14,
            fontFamily: 'BRFirma-Medium',
          },
          Table: {
            headerColor: "#335642",
            fontSize: 12,
            headerSplitColor: "transparent",
            colorBgContainer: "transparent",
            headerBg: "transparent",
            borderColor: "#8DC467",
            rowHoverBg: "#E4F2D6",
            rowSelectedBg: "#E4F2D6",
            fontWeightStrong: 700,
            fontFamily: 'BRFirma-Medium',
            colorLinkHover: '#8DC467',
            controlItemBgActiveHover: '#8DC467',
            cellPaddingBlock: 10,
            cellPaddingInline: 8
          },
          Pagination: {
            itemActiveBg: "#335642",
            colorPrimaryBorder: "transparent",
            itemBg: "transparent",
            colorBorder: "transparent",
            controlOutline: "#335642",
            colorBorderBg: 'transparent'
          },
          Spin: {
            colorPrimary: '#8dc467',
          },
          Checkbox: {
            colorPrimary: '#8dc467',
            colorPrimaryHover: 'none',
            colorBgContainer: '#fff',
            colorBorder: '#335642',
            colorPrimaryBorder: '#fff',
            controlItemBgActive: '#fff',
          },
          Modal:{
            padding: 0,
            paddingLG: 0,
            paddingMD: 0
           },
           Divider: {
            colorSplit: "#8DC467",
            marginLG:0,
           },
           Radio:{
            buttonSolidCheckedActiveBg: "#8DC467",
            buttonSolidCheckedBg: "#8DC467",
            colorPrimary: "#11643C",
            fontFamily: 'BRFirma-Medium',
          },
           
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
